import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGeeksforgeeksComponent } from './simple-icons-geeksforgeeks.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGeeksforgeeksComponent ],
    exports:      [ SimpleIconsGeeksforgeeksComponent ],
    bootstrap:    []
})
export class SimpleIconsGeeksforgeeksModule {}
